import { render, staticRenderFns } from "./DxSelectDate.vue?vue&type=template&id=f8fa9520&"
import script from "./DxSelectDate.vue?vue&type=script&lang=js&"
export * from "./DxSelectDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports